import { CheckoutState } from '../../state';

export const hasApplePayAsyncErrors = (state: CheckoutState) =>
    state.applepay.hasAsyncErrors;

export const getIsApplePaySupported = (state: CheckoutState) =>
    state.applepay.isApplePaySupported;

export const getCanMakePaymentsWithActiveCard = (state: CheckoutState) =>
    state.applepay.canMakePaymentsWithActiveCard;

export const getApplePayInstance = (state: CheckoutState) =>
    state.applepay.applepayInstance;

export const getIsMakingApplePayPayment = (state: CheckoutState) =>
    state.applepay.isMakingApplePayPayment;
